import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router'
import * as Sentry from '@sentry/react'
import { App } from './App'
import { ServerErrorState } from './pages/ServerErrorState'
import { trackError } from './lib/analytics'
import './index.css'

// Sentry: дедупликация ошибок + красивый UI с группировкой.
// DSN задаётся через VITE_SENTRY_DSN в env. Если пуст — Sentry не активируется.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [Sentry.browserTracingIntegration()],
  })
}

// BetterStack: те же ошибки дублируем в lk-source для SQL-аналитики
// (когда нужно посчитать «у скольких % юзеров рассылочной кампании Х
// случилась ошибка Y» — это удобнее SQL-ом, чем в Sentry-UI).
window.addEventListener('error', (e) => {
  trackError(e.error || new Error(e.message), 'window.onerror')
})
window.addEventListener('unhandledrejection', (e) => {
  trackError(e.reason, 'unhandledrejection')
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ eventId }) => (
        <ServerErrorState
          onRetry={() => window.location.reload()}
          eventId={eventId}
        />
      )}
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
)
